import { createTheme, alpha } from "@mui/material/styles";
import { ruRU } from "@mui/material/locale";

// Фирменные цвета — те же, что на страницах входа (wwwroot/css/auth.css)
export const brand = {
  main: "#c8611d",
  dark: "#ad5218",
  light: "#e8894a",
  ink: "#1f2a33",
  slate: "#2f3d4a",
  muted: "#5b6b78",
  line: "#e3e8ec",
  surface: "#ffffff",
  background: "#f4f6f8",
  success: "#2e8b57",
  danger: "#c0392b",
};

const appTheme = createTheme(
  {
    palette: {
      primary: { main: brand.main, dark: brand.dark, light: brand.light, contrastText: "#fff" },
      secondary: { main: brand.slate, contrastText: "#fff" },
      success: { main: brand.success },
      error: { main: brand.danger },
      text: { primary: brand.ink, secondary: brand.muted },
      background: { default: brand.background, paper: brand.surface },
      divider: brand.line,
    },
    shape: { borderRadius: 12 },
    typography: {
      fontFamily: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      h4: { fontWeight: 700, fontSize: "1.75rem" },
      h5: { fontWeight: 700, fontSize: "1.3rem" },
      h6: { fontWeight: 600, fontSize: "1.1rem" },
      subtitle1: { fontWeight: 600 },
      button: { textTransform: "none", fontWeight: 600 },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: { body: { backgroundColor: brand.background } },
      },
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: { borderRadius: 10, padding: "8px 18px" },
          sizeSmall: { padding: "5px 12px" },
          sizeLarge: { padding: "12px 22px", fontSize: "1rem" },
        },
      },
      MuiPaper: {
        styleOverrides: {
          rounded: { borderRadius: 16 },
          elevation1: { boxShadow: "0 1px 2px rgba(16,24,40,.06), 0 1px 3px rgba(16,24,40,.08)" },
          elevation3: { boxShadow: "0 4px 16px rgba(16,24,40,.08)" },
        },
      },
      MuiCard: {
        defaultProps: { elevation: 0 },
        styleOverrides: { root: { border: `1px solid ${brand.line}`, borderRadius: 16 } },
      },
      MuiCardContent: { styleOverrides: { root: { padding: 20, "&:last-child": { paddingBottom: 20 } } } },
      MuiAppBar: {
        styleOverrides: { root: { boxShadow: `0 1px 0 ${brand.line}` } },
      },
      MuiDrawer: {
        styleOverrides: { paper: { borderRight: `1px solid ${brand.line}` } },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            margin: "2px 8px",
            "&.Mui-selected": {
              backgroundColor: alpha(brand.main, 0.12),
              color: brand.main,
              "& .MuiListItemIcon-root": { color: brand.main },
              "&:hover": { backgroundColor: alpha(brand.main, 0.18) },
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            backgroundColor: brand.surface,
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: brand.main },
          },
          notchedOutline: { borderColor: "#cfd7de" },
        },
      },
      MuiDialog: {
        styleOverrides: { paper: { borderRadius: 16 } },
      },
      MuiDialogTitle: { styleOverrides: { root: { fontWeight: 700 } } },
      MuiTab: { styleOverrides: { root: { textTransform: "none", fontWeight: 600 } } },
      MuiAccordion: {
        defaultProps: { disableGutters: true, elevation: 0 },
        styleOverrides: {
          root: {
            border: `1px solid ${brand.line}`,
            borderRadius: 12,
            marginBottom: 12,
            "&:before": { display: "none" },
            "&:first-of-type": { borderRadius: 12 },
            "&:last-of-type": { borderRadius: 12 },
          },
        },
      },
      MuiAlert: { styleOverrides: { root: { borderRadius: 12 } } },
      MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
      MuiTableCell: { styleOverrides: { head: { fontWeight: 700 } } },
    },
  },
  ruRU
);

export default appTheme;
